<q9-section>
  <span title>{{ 'CORE.TAGS.TAG_LABEL' | translate }}</span>

  <div content>
    <q9-tags-select [formControl]="tagsControl"></q9-tags-select>
  </div>
</q9-section>
